import { useUpdateEffect } from 'react-use';

import { ReceptionServiceWithPractitionersSimpleQuery } from '@dreryk/egabinet-private-medical-service-frontend-api';
import { ReceptionServiceId } from '@dreryk/egabinet-private-medical-service-published-language-api';

import { refetchCqrsQuery } from '@dreryk/command-query-react-common';
import { useBoolean } from '@dreryk/react-common';

import { PractitionerReceptionServiceUpdateModal } from './PractitionerReceptionServiceUpdateModal';

type PractitionerReceptionServiceUpdateModalOpenerRenderer = (renderProps: { openModal: VoidFunction }) => JSX.Element;

type PractitionerReceptionServiceUpdateModalOpenerProps = {
   readonly receptionServiceId: ReceptionServiceId;
   readonly practitionerId: number;
   readonly children: PractitionerReceptionServiceUpdateModalOpenerRenderer;
};

export const PractitionerReceptionServiceUpdateModalOpener = (
   props: PractitionerReceptionServiceUpdateModalOpenerProps
): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);

   useUpdateEffect(() => {
      if (!modalOpened) {
         refetchCqrsQuery(ReceptionServiceWithPractitionersSimpleQuery);
      }
   }, [modalOpened]);

   return (
      <>
         {props.children({
            openModal: openModal,
         })}
         {modalOpened ? (
            <PractitionerReceptionServiceUpdateModal
               receptionServiceId={props.receptionServiceId}
               practitionerId={props.practitionerId}
               onClose={closeModal}
               onSuccess={closeModal}
            />
         ) : null}
      </>
   );
};
